import {
  AfterViewInit,
  Component,
  OnDestroy,
  OnInit,
  Input,
  Output, EventEmitter
} from '@angular/core';


import {ActionService} from "@/services/action.service";


import {Logger} from '@/util/logger';


import {ActivatedRoute, Router} from '@angular/router';

import {IProjectRow} from "@/screens/administration/i.project.row";
import {ProjectService} from "@/services/project.service";
import {IUserRow} from "@/screens/administration/i.user.row";
import {IOrganizationRow} from "@/screens/administration/i.organization.row";
import {first} from "rxjs/operators";
import {UserService} from "@/services/user.service";

@Component({
  standalone: false,
  selector:    'user-list-component',
  template: `<div class="user-list-wrapper">

    <ul>
      <li *ngFor="let user of users">

        <!-- user avatar -->

        <span class="user-list-row-cell" style="min-width: 32px;">

          <a class="user-list-row-link" href="/users/{{user.key ? user.key : user.userid}}"><img src="{{user.icon ? user.icon : '/assets/images/profile-512.png'}}" referrerpolicy="no-referrer"></a>

        </span>

        <!-- user's display name, email and userid -->

        <span class="user-list-row-cell" style="width: 260px">

          <span style="font-size: 11px; font-weight: normal; color: grey; width: 100%; display: block;">
            <a class="user-list-row-link" href="/users/{{user.key ? user.key : user.userid}}">{{user.email}}</a>
          </span>

          <span style="font-size: 24px; color: black; font-weight: normal; display: block;">
            <a class="user-list-row-link" href="/users/{{user.key ? user.key : user.userid}}"><b>{{user.name ? user.name : user.display_name}}</b></a>
          </span>

        </span>

        <span class="user-list-row-cell" style="width: 180px;">
          <span style="font-size: 11px; font-weight: normal; color: grey; width: 100%; display: block;">
            <b><i>{{user.key ? user.key : user.userid}}</i></b>
          </span>
          <span style="font-size: 11px; font-weight: normal; color: grey;">
            {{user.created_at}}
          </span>
        </span>

        <div *ngIf="pending; then thenBlock else elseBlock"></div>

        <ng-template #thenBlock>

          <!-- this is the pending users list (for either the project or org screens -->

          <span title="{{addHelp}}" (click)="approveAndAdd(user.key ? user.key : user.userid)" *ngIf="editable" class="user-list-row-cell approve-and-add-user-action">
            <img width="16" src="/assets/images/create-user.png">
          </span>

          <span class="user-list-row-cell-add-help">
           {{addHelp}}
          </span>

        </ng-template>

        <ng-template #elseBlock>

          <!-- when editable we allow the user to link/unlink the users from the org or project -->

          <span (click)="unlinkAdmin(user.key ? user.key : user.userid)" *ngIf="editable" class="user-list-row-cell unlink-admin-user-action">
            <img width="16" src="/assets/images/delete-64.png">
          </span>

        </ng-template>

    </ul>

  </div>`
})

/**
 *
 * @class UsersListComponent
 *
 * render a list of the given users via @input
 *
 * - - - - - - - - - - - - - - - - - - -
 * @author    Michael Garvin (mike.garvin@ironroad.ca)
 * @date      August 2022
 *
 */
export class UsersListComponent implements OnInit, OnDestroy, AfterViewInit {

  /** can we edit the projects? */
  @Input() editable: boolean      = false;

  /** is this the pending users list? */
  @Input() pending: boolean       = false;

  /** the organization the (admin) users are linked to */
  @Input() org: IOrganizationRow  = null;

  /** the project the (member) users are linked to */
  @Input() proj: IProjectRow      = null;

  /** the set of users being rendered */
  @Input() users: IUserRow[]      = [];

  /** when we unlink project members, let the parent know it needs to update */
  @Output() member_unlinked = new EventEmitter<IUserRow>();

  /** when we unlink org admins, let the parent know it needs to update */
  @Output() admin_unlinked = new EventEmitter<IUserRow>();

  /** when we approve a user (but not add them at the same time) */
  @Output() member_approve = new EventEmitter<IUserRow>();

  /** when we approve a user AND add them at the same time */
  @Output() member_approve_and_add = new EventEmitter<IUserRow>();

  public addHelp: string = '';

  /**
   * standard constructor
   *
   * @param router     in case we need to redirect the page
   * @param actions    the GUI actions we can invoke
   * @param route      the active URL
   * @param prjservice for working with projects
   * @param usrservice for working with users
   *
   */
  constructor(
    private router:     Router,
    private actions:    ActionService,
    private route:      ActivatedRoute,
    private prjservice: ProjectService,
    private usrservice: UserService
  ) {


  }

  /* on creation subscribe to the alert service so we get updates when alerts happen from anywhere */
  ngOnInit() {

    let ul: UsersListComponent = this;

    Logger.debug('[UserListComponent] init...');



  }

  ngAfterViewInit() {

    if (this.proj) {

      this.addHelp = "Add as non-admin member only to this Project";

    } else {

      this.addHelp = "Add as Organization Administrator (can admin all org projects)";
    }
  }

  /* clean up at the end */
  ngOnDestroy() {

  }

  /** it's a pending user, tell the parent to approve only */
  approve(userid: string) {

    let ul: UsersListComponent = this;
    let user: IUserRow = ul.users.find(x => x.userid == userid);

    ul.member_approve.emit(user);
  }

  /** it's a pending user, tell the parent to approve and add them */
  approveAndAdd(userid: string) {

    let ul: UsersListComponent = this;
    let user: IUserRow = ul.users.find(x => x.userid == userid);

    ul.member_approve_and_add.emit(user);
  }

  /** unlink this user as an admin for the organization */
  unlinkAdmin(userid: string) {

    let ul: UsersListComponent = this;
    let user: IUserRow = ul.users.find(x => x.userid == userid);

    if (!user) {

      user = ul.users.find(x => x.key == userid);
    }

    if (!user) {

      return ;
    }

    if (ul.org) {

      Logger.debug('[UserListComponent] unlinking org admin: ', user);

      ul.usrservice.unlinkOrganization(ul.org.id, Number(user.id))
        .pipe(first())
        .subscribe({

          next: (data: any): void => {

            if (data.result) {

              data = data.result;
            }

            Logger.debug(`[UserListComponent] unlinked!`, data);

            ul.users = ul.users.filter(x => x.id != user.id);

            ul.admin_unlinked.emit(user);


          },

          error: (error: any): void => {

            Logger.error(`[UserListComponent] could not unlink org admin:`, error);
          }

        });

    } else if (ul.proj) {

      Logger.debug('[UserListComponent] unlinking project member: ', user);

      ul.usrservice.unlinkMember(ul.proj.id, Number(user.id))
        .pipe(first())
        .subscribe({

          next: (data: any): void => {

            if (data.result) {

              data = data.result;
            }

            Logger.debug(`[UserListComponent] unlinked!`, data);

            ul.users = ul.users.filter(x => x.id != user.id);

            ul.member_unlinked.emit(user);


          },

          error: (error: any): void => {

            Logger.error(`[UserListComponent] could not unlink member:`, error);
          }

        });

    }

  }
}
